'use client'
import { FunctionComponent, useCallback, useState } from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react-lite'

import { Switch } from '@/components/Switch'
import { niceSwitch } from '@/store/NiceSwitch'
import { Icon } from '@/icons'

import { Word } from '@/domains/Account/modules/Mktu/components/Word'
import { InfoPopup } from './components/InfoPopup'

import styles from './NiceSwitch.module.scss'

interface NiceSwitch {
  className?: string
  value: boolean
  onChange: (value: boolean) => void
}
export const NiceSwitch: FunctionComponent<NiceSwitch> = observer(
  ({ className, value = true, onChange }) => {
    const [visibleHelpInfo, setVisibleHelpInfo] = useState(false)
    const showHelpInfo = useCallback(() => {
      setVisibleHelpInfo(true)
    }, [])

    const hideHelpInfo = useCallback(() => {
      setVisibleHelpInfo(false)
    }, [])

    const showAttention = useCallback(() => {
      niceSwitch.setVisibleAttention(true)
    }, [])

    const hideAttention = useCallback(() => {
      niceSwitch.setVisibleAttention(false)
    }, [])

    const changeNice = useCallback(
      (value: boolean) => {
        onChange(value)
        if (!niceSwitch.attentionIsRead) {
          if (value) {
            hideAttention()
          } else {
            showAttention()
          }
        }
      },
      [onChange, showAttention, hideAttention]
    )

    const acceptDisableNice = useCallback(() => {
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('attentionNiceIsRead', 'true')
      }
      niceSwitch.setAttentionIsRead(true)
      niceSwitch.setVisibleAttention(false)
    }, [])

    return (
      <div className={cn(styles.switchNiceContainer, className)}>
        <Switch
          className={styles.switchNice}
          checked={value}
          onChange={changeNice}
          label="Только НИЦЦА"
          direction="right"
        ></Switch>
        <button onClick={showHelpInfo}>
          <Icon name="question" className={styles.questionIcon} />
        </button>
        <InfoPopup
          isVisible={niceSwitch.visibleAttention}
          onClose={hideAttention}
        >
          При отключении есть риск ошибки в подборе классов в виду непринятия
          Роспатентом терминов за пределами классификации МКТУ
          <button
            className={styles.attentionNiceAcceptButton}
            onClick={acceptDisableNice}
          >
            Понятно
          </button>
        </InfoPopup>
        <InfoPopup
          isVisible={visibleHelpInfo}
          onClose={hideHelpInfo}
          withoutCloseButton
          closeOnClickOutside
        >
          <div className={styles.helpNiceDescription}>
            Ницца <span className={styles.charNice}>N</span> — это Международная
            классификация товаров и услуг (МКТУ), которая используется для
            регистрации товарных знаков. Она делит все товары и услуги на 45
            классов, что помогает уточнять сферу использования бренда.
          </div>
          <div className={styles.helpNiceAnnotation}>
            <span className={styles.charNice}>N</span> — обозначение для слов
            из классификации НИЦЦА. Пример:
          </div>
          <Word
            className={styles.helpNiceWord}
            id="testId"
            name="Чай"
            isNice
            isReadonly
            isDeletable={false}
          />
        </InfoPopup>
      </div>
    )
  }
)
